<script>
/* global axios */
// Botão de ligação Wavoip no header da conversa. Só aparece quando a caixa tem
// token Wavoip configurado. Inicia a chamada para o telefone do contato.
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import { useWavoip } from 'dashboard/composables/useWavoip';
import ButtonV4 from 'dashboard/components-next/button/Button.vue';

export default {
  components: { ButtonV4 },
  setup() {
    const { startCall, init } = useWavoip();
    return { startCall, init };
  },
  data() {
    return { hasToken: false, calling: false };
  },
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
      accountId: 'getCurrentAccountId',
    }),
    inboxId() {
      return this.currentChat?.inbox_id;
    },
    phone() {
      return this.currentChat?.meta?.sender?.phone_number;
    },
  },
  watch: {
    inboxId: {
      immediate: true,
      handler() {
        this.checkToken();
      },
    },
  },
  methods: {
    async checkToken() {
      this.hasToken = false;
      if (!this.inboxId) return;
      try {
        const { data } = await axios.get(
          `/api/v1/accounts/${this.accountId}/kanban/wavoip_tokens`,
          { params: { inbox_id: this.inboxId } }
        );
        this.hasToken = !!data.data?.device_token;
        // Caixa Wavoip detectada: registra o device JÁ (abre o WebSocket +
        // handlers de entrada), sem esperar a atendente fazer uma ligação. Assim
        // ela fica disponível p/ RECEBER ligação assim que abre a conversa.
        // Idempotente (só a 1ª vez conecta de fato). Registra todos os tokens da
        // conta, então vale p/ qualquer caixa Wavoip, não só a atual.
        if (this.hasToken) this.init(this.accountId);
      } catch (e) {
        this.hasToken = false;
      }
    },
    async call() {
      if (!this.phone) {
        useAlert(this.$t('CONVERSATION.WAVOIP.NO_PHONE'));
        return;
      }
      this.calling = true;
      try {
        // passa a conversa/caixa p/ registrar a ligação NA CONVERSA (bolha de
        // ligação) além do relatório de Ligações.
        await this.startCall(this.accountId, this.phone, {
          conversationId: this.currentChat?.id,
          inboxId: this.inboxId,
        });
      } catch (e) {
        // mostra o motivo real do Wavoip (err.devices[].reason) quando houver,
        // em vez do erro genérico — ajuda a diagnosticar "chama e cai".
        useAlert(e?.message || this.$t('CONVERSATION.WAVOIP.ERROR'));
      } finally {
        this.calling = false;
      }
    },
  },
};
</script>

<template>
  <ButtonV4
    v-if="hasToken"
    v-tooltip="$t('CONVERSATION.WAVOIP.CALL')"
    size="sm"
    variant="ghost"
    color="slate"
    icon="i-lucide-phone"
    :is-loading="calling"
    class="rounded-md hover:bg-n-alpha-2"
    @click="call"
  />
</template>
